// Update the courseData.js file to include links to downloadable resources
const courseData = [
  {
    id: 1,
    title: "Introduction to Ink Drawing",
    description: "Learn about the basic materials and techniques used in ink drawing. Understand the unique properties of ink as a medium and how to get started with simple exercises.",
    objectives: [
      "Understand the different types of ink drawing tools and materials",
      "Learn proper handling and care of ink drawing instruments",
      "Practice basic line control exercises",
      "Develop confidence with permanent media"
    ],
    resources: [
      {
        name: "Materials Checklist",
        path: "/resources/materials_checklist.pdf",
        description: "Complete list of recommended materials for the course"
      },
      {
        name: "Line Practice Sheet",
        path: "/resources/line_practice_sheet.pdf",
        description: "Exercises to develop line control and confidence"
      }
    ],
    completed: false
  },
  {
    id: 2,
    title: "Line Work Fundamentals",
    description: "Explore the expressive potential of line in ink drawing. Learn how different line weights, qualities, and patterns can create depth, texture, and emotion in your drawings.",
    objectives: [
      "Master various line weights and qualities",
      "Understand how line direction affects perception",
      "Practice creating depth and form using only lines",
      "Develop a personal line vocabulary"
    ],
    resources: [
      {
        name: "Line Weight Practice Sheet",
        path: "/resources/line_weight_practice.pdf",
        description: "Exercises to develop control over line weight and quality"
      }
    ],
    completed: false
  },
  {
    id: 3,
    title: "Hatching Techniques",
    description: "Learn the art of hatching and cross-hatching to create tone and texture in ink drawings. Discover how the direction, spacing, and layering of lines can create a wide range of values and surface qualities.",
    objectives: [
      "Master basic hatching techniques",
      "Develop cross-hatching skills for creating tone",
      "Learn contour hatching to show form",
      "Create smooth gradations of value using hatching"
    ],
    resources: [
      {
        name: "Hatching Grids",
        path: "/resources/hatching_grids.pdf",
        description: "Practice templates for developing hatching techniques"
      }
    ],
    completed: false
  },
  {
    id: 4,
    title: "Stippling and Pointillism",
    description: "Discover the technique of building tone and texture through dots. Learn how the density, size, and pattern of dots can create subtle gradations and textures in your ink drawings.",
    objectives: [
      "Understand the principles of stippling",
      "Control dot density to create value",
      "Create texture using stippling techniques",
      "Develop patience and precision in mark-making"
    ],
    resources: [
      {
        name: "Stippling Practice Sheet",
        path: "/resources/stippling_practice.pdf",
        description: "Exercises to develop stippling techniques and control"
      }
    ],
    completed: false
  },
  {
    id: 5,
    title: "Ink Wash Techniques",
    description: "Explore the fluid properties of ink through wash techniques. Learn how diluted ink can create soft gradations and atmospheric effects that contrast beautifully with crisp line work.",
    objectives: [
      "Prepare and control ink washes",
      "Create value scales using wash techniques",
      "Combine line work with wash",
      "Understand wet-on-wet and wet-on-dry techniques"
    ],
    resources: [
      {
        name: "Wash Technique Guide",
        path: "/resources/wash_technique_guide.pdf",
        description: "Step-by-step guide to creating and controlling ink washes"
      }
    ],
    completed: false
  },
  {
    id: 6,
    title: "Texture and Pattern Development",
    description: "Learn to create a variety of textures and patterns in ink. Discover how to observe and translate real-world textures into your drawings using various ink techniques.",
    objectives: [
      "Analyze and break down common textures",
      "Develop a library of texture techniques",
      "Create convincing representations of materials",
      "Use pattern to enhance your drawings"
    ],
    resources: [
      {
        name: "Texture Reference Sheet",
        path: "/resources/texture_reference.pdf",
        description: "Reference guide for creating common textures in ink"
      }
    ],
    completed: false
  },
  {
    id: 7,
    title: "Composition and Negative Space",
    description: "Understand the principles of effective composition in ink drawing. Learn how to use negative space as an active element in your compositions and create balanced, dynamic arrangements.",
    objectives: [
      "Apply compositional rules and guidelines",
      "Use negative space effectively",
      "Create focal points and visual hierarchy",
      "Develop balanced compositions"
    ],
    resources: [
      {
        name: "Composition Template",
        path: "/resources/composition_template.pdf",
        description: "Templates and guides for practicing composition principles"
      }
    ],
    completed: false
  },
  {
    id: 8,
    title: "Drawing from Observation",
    description: "Apply ink techniques to observational drawing. Learn strategies for accurately translating what you see into ink drawings with confidence and precision.",
    objectives: [
      "Develop accurate observation skills",
      "Translate 3D forms to 2D drawings",
      "Understand proportion and scale",
      "Render light and shadow in ink"
    ],
    resources: [
      {
        name: "Proportion Guide",
        path: "/resources/proportion_guide.pdf",
        description: "Techniques for achieving accurate proportions in your drawings"
      }
    ],
    completed: false
  },
  {
    id: 9,
    title: "Stylization and Expression",
    description: "Develop your personal style in ink drawing. Learn how to move beyond strict representation toward more expressive and stylized approaches.",
    objectives: [
      "Understand stylization approaches",
      "Develop expressive mark-making",
      "Explore abstraction techniques",
      "Begin developing a personal style"
    ],
    resources: [
      {
        name: "Style Worksheet",
        path: "/resources/style_worksheet.pdf",
        description: "Exercises to help develop your personal drawing style"
      }
    ],
    completed: false
  },
  {
    id: 10,
    title: "Final Project - Complete Composition",
    description: "Apply all the techniques you've learned to create a complete ink drawing. Learn the process of planning, executing, and refining a finished piece from start to finish.",
    objectives: [
      "Plan a complete composition",
      "Select appropriate techniques for different elements",
      "Execute a finished ink drawing",
      "Evaluate and refine your work"
    ],
    resources: [
      {
        name: "Final Project Guide",
        path: "/resources/final_project_guide.pdf",
        description: "Step-by-step planning guide for your final ink drawing project"
      }
    ],
    completed: false
  }
];

export default courseData;
